interface BreadcrumbItem {
  name: string
  url: string
}

interface StructuredDataOptions {
  breadcrumbs?: BreadcrumbItem[]
}

/**
 * Composable to inject additional structured data (JSON-LD) into page head.
 * The base Organization schema is configured in nuxt.config.ts via schemaOrg.identity.
 * This composable adds page-specific schemas like LocalBusiness and Breadcrumbs.
 */
export function useStructuredData(options?: StructuredDataOptions) {
  const siteUrl = 'https://baghera-advisory.fr'

  // Add LocalBusiness schema (extends Organization with local details)
  useSchemaOrg([
    defineLocalBusiness({
      '@type': 'LocalBusiness',
      'name': 'Baghera Advisory',
      'description': "Conseil stratégique au service des dirigeants. Réflexions stratégiques, optimisation de l'organisation et mise en œuvre des leviers de performance.",
      'image': `${siteUrl}/img/desktop/panther_1440x532.webp`,
      'telephone': '+33 6 77 95 69 04',
      'email': 'g.sachnine@baghera-advisory.fr',
      'url': siteUrl,
      'address': {
        '@type': 'PostalAddress',
        'streetAddress': '88 Avenue Jean Cordier',
        'addressLocality': 'Pessac',
        'postalCode': '33600',
        'addressCountry': 'FR',
      },
      'geo': {
        '@type': 'GeoCoordinates',
        'latitude': 44.8053,
        'longitude': -0.6309,
      },
      'areaServed': {
        '@type': 'Country',
        'name': 'France',
      },
      'priceRange': '$$',
      'sameAs': [
        'https://www.linkedin.com/in/gregory-sachnine-b7124a100/',
      ],
    }),
  ])

  // Add breadcrumb schema if provided
  if (options?.breadcrumbs && options.breadcrumbs.length > 0) {
    useSchemaOrg([
      defineBreadcrumb({
        itemListElement: options.breadcrumbs.map((item, index) => ({
          '@type': 'ListItem',
          'position': index + 1,
          'name': item.name,
          'item': item.url.startsWith('http') ? item.url : `${siteUrl}${item.url}`,
        })),
      }),
    ])
  }
}

/**
 * Composable for adding Person schema (used on About section)
 */
export function usePersonSchema() {
  const siteUrl = 'https://baghera-advisory.fr'

  useSchemaOrg([
    definePerson({
      'name': 'Grégory Sachnine',
      'jobTitle': 'Fondateur & Consultant',
      'description': "Fort de 30 ans d'expérience en direction financière et direction générale dans des groupes industriels, Grégory Sachnine apporte une expertise unique et une compréhension fine des enjeux stratégiques des entreprises.",
      'url': siteUrl,
      'sameAs': [
        'https://www.linkedin.com/in/gregory-sachnine-b7124a100/',
      ],
      'worksFor': {
        '@type': 'Organization',
        'name': 'Baghera Advisory',
        'url': siteUrl,
      },
    }),
  ])
}
